<template>
    <div class="internet-table">
        <v-data-table :loading="loader" disable-initial-sort :rows-per-page-items="rowPerPage" :headers="headers" class="custom-data-table"
            :items="grouped_items" item-key="id">
            <template #headers="props">
                <tr class="first-header">
                    <th :class="['fw-bold', `text-xs-${header.align}`, getHeaderClass(header.value)]"
                        v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
                </tr>
            </template>
            <template #items="props">
                <tr @click="props.item.has_auxiliary ? toggleExpand(props.item.user) : null">
                    <td class="text-center text-no-wrap">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon small color="#464D69">settings</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile v-if="!props.item.room_state_id"
                                    @click="openDialog(props.item, 'activate')">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-wifi-alt"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Kích hoạt Internet</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="props.item.room_state_id" @click="openDialog(props.item, 'cancel')">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-wifi-off"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Ngừng sử dụng internet</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="openDialog(props.item, 'change')">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-refresh-alt"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Chuyển mạng</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="props.item.status === 0" @click="openDialog(props.item, 'cut')">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-cloud-off"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Cắt line VNPT</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="props.item.wifi_type !== 'auxiliary'"
                                    @click="openDialog(props.item, 'add_room')">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-plus"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Thêm phòng</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="openDialog(props.item, 'edit_price')">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-edit"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Chỉnh sửa giá</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="openDialog(props.item, 'schedule_price')">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-calendar"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Lên lịch thay đổi giá</v-list-tile-title>
                                </v-list-tile>

                            </v-list>
                        </v-menu>
                    </td>
                    <td class="text-center text-no-wrap">
                        <span :class="['v-badge', wifi_type_badges[props.item.wifi_type].badge]">{{
                            wifi_type_badges[props.item.wifi_type].text }}</span>
                    </td>
                    <td class="text-left text-no-wrap">
                        <div class="d-flex align-center">
                            <span>{{ props.item.user }}</span>

                            <v-icon v-if="props.item.has_auxiliary" small>{{ expanded_users.includes(props.item.user) ?
                                'expand_less' :
                                'expand_more' }}</v-icon>

                        </div>
                    </td>
                    <td class="text-center text-no-wrap">{{ props.item.package_name || '' }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.speed_mbps || '' }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.building_text }}</td>
                    <td class="text-center text-no-wrap">
                        <span :class="['v-badge', internet_status[props.item.status].badge]">{{
                            internet_status[props.item.status].text }}</span>
                    </td>
                    <td class="text-center text-no-wrap">{{ props.item.date_schedule_out | formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.price | formatNumber }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.customer_price | formatNumber }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.date_start | formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.wifi_name }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.wifi_password }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.renewal_start_date | formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.renewal_end_date | formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">
                        <v-edit-dialog lazy>
                            <div>{{ props.item.vnpt_invoice }}</div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="props.item.vnpt_invoice"
                                    label="Hóa đơn VNPT"
                                    single-line
                                    counter
                                    @blur="updateVnptInvoice(props.item)"
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                </tr>
                <!-- Hiển thị các WiFi phụ khi expanded -->
                <template v-if="props.item.has_auxiliary && expanded_users.includes(props.item.user)">
                    <tr v-for="auxiliary_item in getAuxiliaryItems(props.item.user)" :key="auxiliary_item._id"
                        class="auxiliary-row">
                        <td class="text-center text-no-wrap">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon small color="#464D69">settings</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-tile v-if="!auxiliary_item.room_state_id"
                                        @click="openDialog(auxiliary_item, 'activate')">
                                        <v-list-tile-action>
                                            <v-icon small class="zmdi zmdi-wifi-alt"></v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Kích hoạt Internet</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile v-if="auxiliary_item.room_state_id"
                                        @click="openDialog(auxiliary_item, 'cancel')">
                                        <v-list-tile-action>
                                            <v-icon small class="zmdi zmdi-wifi-off"></v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Ngừng sử dụng internet</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="openDialog(auxiliary_item, 'change')">
                                        <v-list-tile-action>
                                            <v-icon small class="zmdi zmdi-refresh-alt"></v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Chuyển mạng</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile v-if="auxiliary_item.status === 0"
                                        @click="openDialog(auxiliary_item, 'cut')">
                                        <v-list-tile-action>
                                            <v-icon small class="zmdi zmdi-cloud-off"></v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Cắt line VNPT</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="openDialog(auxiliary_item, 'edit_price')">
                                        <v-list-tile-action>
                                            <v-icon small class="zmdi zmdi-edit"></v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Chỉnh sửa giá</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="openDialog(auxiliary_item, 'schedule_price')">
                                        <v-list-tile-action>
                                            <v-icon small class="zmdi zmdi-calendar"></v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Lên lịch thay đổi giá</v-list-tile-title>
                                    </v-list-tile>

                                </v-list>
                            </v-menu>
                        </td>
                        <td class="text-center text-no-wrap">
                            <span :class="['v-badge', wifi_type_badges[auxiliary_item.wifi_type].badge]">{{
                                wifi_type_badges[auxiliary_item.wifi_type].text }}</span>
                        </td>
                        <td class="text-left text-no-wrap pl-4">
                            <span class="text-muted">{{ auxiliary_item.user }}</span>
                        </td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.package_name || '' }}</td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.speed_mbps || '' }}</td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.room_id }}</td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.building_text }}</td>
                        <td class="text-center text-no-wrap">
                            <span :class="['v-badge', internet_status[auxiliary_item.status].badge]">{{
                                internet_status[auxiliary_item.status].text }}</span>
                        </td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.date_schedule_out | formatTimeServer }}
                        </td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.price | formatNumber }}</td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.customer_price | formatNumber }}</td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.date_start | formatTimeServer }}</td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.wifi_name }}</td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.wifi_password }}</td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.renewal_start_date | formatTimeServer
                        }}</td>
                        <td class="text-center text-no-wrap">{{ auxiliary_item.renewal_end_date | formatTimeServer }}
                        </td>
                        <td class="text-center text-no-wrap">
                            <v-edit-dialog lazy>
                                <div>{{ auxiliary_item.vnpt_invoice || '-' }}</div>
                                <template v-slot:input>
                                    <v-text-field
                                        v-model="auxiliary_item.vnpt_invoice"
                                        label="Hóa đơn VNPT"
                                        single-line
                                        counter
                                        @blur="updateVnptInvoice(auxiliary_item)"
                                    ></v-text-field>
                                </template>
                            </v-edit-dialog>
                        </td>
                    </tr>
                </template>
            </template>
            <template #no-data>Chưa có thông tin</template>
        </v-data-table>
        <change-room-id-dialog @changeDialogState="change_room_id_dialog = $event" @reloadTable="getData"
            :dialog="change_room_id_dialog" :internet_user="chosen_internet_user"
            @close="change_room_id_dialog = false"></change-room-id-dialog>
        <activate-internet-dialog @changeDialogState="activate_internet_dialog = $event" @reloadTable="getData"
            :dialog="activate_internet_dialog" :internet_user="chosen_internet_user"
            @close="activate_internet_dialog = false"></activate-internet-dialog>
        <cancel-internet-room-dialog @changeDialogState="cancel_internet_dialog = $event" @reloadTable="getData"
            :dialog="cancel_internet_dialog" :internet_user="chosen_internet_user"
            @close="cancel_internet_dialog = false"></cancel-internet-room-dialog>
        <cut-internet-dialog @changeDialogState="cut_internet_dialog = $event" @reloadTable="getData"
            :dialog="cut_internet_dialog" :internet_user="chosen_internet_user"
            @close="cut_internet_dialog = false"></cut-internet-dialog>
        <add-room-dialog @changeDialogState="add_room_dialog = $event" @reloadTable="getData" :dialog="add_room_dialog"
            :internet_user="chosen_internet_user" @close="add_room_dialog = false"></add-room-dialog>
        <edit-price-dialog @changeDialogState="edit_price_dialog = $event" @reloadTable="getData"
            :dialog="edit_price_dialog" :internet_user="chosen_internet_user"
            @close="edit_price_dialog = false"></edit-price-dialog>
        
        <schedule-price-edit @changeDialogState="schedule_price_dialog = $event" @reloadTable="getData"
            :dialog="schedule_price_dialog" :internet_user="chosen_internet_user"
            @close="schedule_price_dialog = false"></schedule-price-edit>

        <export-csv-button :trigger="export_csv.trigger" :title="export_csv.title"
            :rows="export_csv.rows"></export-csv-button>
    </div>
</template>
<script>
import api from "Api";
import ExportCsvButton from "Components/ExportExcel/ExportCsvButton";
import { list_building, WIFI_TYPES, WIFI_TYPE_BADGES } from "Constants/db-config";
import { formatTimeServer } from "Helpers";
import ActivateInternetDialog from "./ActivateInternet";
import AddRoomDialog from "./AddRoom";
import CancelInternetRoomDialog from "./CancelInternetRoom";
import CutInternetDialog from "./CutInternet";

import EditPriceDialog from "./EditPrice";
import SchedulePriceEdit from "./SchedulePriceEdit";
import ChangeRoomIdDialog from "./InternetChangeRoomId";
import { INTERNET_REGISTRATION_STATUS } from "Constants/db-config";

export default {
    props: {
        reload_table: Number,
        search: String,
        chosen_building: String,
        exportCSV: Number,
        filterStatus: {
            type: [String, Number],
            default: null
        }
    },
    components: {
        ChangeRoomIdDialog,
        ActivateInternetDialog,
        CancelInternetRoomDialog,
        CutInternetDialog,
        AddRoomDialog,
        EditPriceDialog,
        SchedulePriceEdit,
        ExportCsvButton
    },
    name: "internet-table",
    data() {
        return {
            headers: [
                { text: "Thao tác", align: "center", sortable: false, value: "action" },
                {
                    text: "Loại wifi",
                    align: "center",
                    sortable: true,
                    value: "wifi_type"
                },
                {
                    text: "Tên user",
                    align: "left",
                    sortable: true,
                    value: "user"
                },
                {
                    text: "Tên gói cước",
                    align: "center",
                    sortable: true,
                    value: "package_name"
                },
                {
                    text: "Tốc độ (Mbps)",
                    align: "center",
                    sortable: true,
                    value: "speed_mbps"
                },
                {
                    text: "Số phòng",
                    align: "center",
                    sortable: true,
                    value: "room_id"
                },
                {
                    text: "Tòa nhà",
                    align: "center",
                    sortable: true,
                    value: "building"
                },
                {
                    text: "Trạng thái",
                    align: "center",
                    sortable: true,
                    value: "status"
                },
                {
                    text: "Ngày trả phòng",
                    align: "center",
                    sortable: true,
                    value: "date_schedule_out"
                },
                {
                    text: "Giá gói cước",
                    align: "center",
                    sortable: true,
                    value: "price"
                },
                {
                    text: "Giá thu KH",
                    align: "center",
                    sortable: true,
                    value: "customer_price"
                },
                {
                    text: "Ngày bắt đầu",
                    align: "center",
                    sortable: true,
                    value: "date_start"
                },
                {
                    text: "Tên wifi",
                    align: "center",
                    sortable: true,
                    value: "wifi_name"
                },
                {
                    text: "Pass wifi",
                    align: "center",
                    sortable: true,
                    value: "wifi_password"
                },
                {
                    text: "Ngày bắt đầu gia hạn",
                    align: "center",
                    sortable: true,
                    value: "renewal_start_date"
                },
                {
                    text: "Ngày kết thúc gia hạn",
                    align: "center",
                    sortable: true,
                    value: "renewal_end_date"
                },
                {
                    text: "Hóa đơn VNPT",
                    align: "center",
                    sortable: true,
                    value: "vnpt_invoice"
                }
            ],
            items: [],
            loader: false,
            rowPerPage: [50, 100, 200, { text: "Tất cả", value: -1 }],
            change_room_id_dialog: false,
            activate_internet_dialog: false,
            cancel_internet_dialog: false,
            cut_internet_dialog: false,
            add_room_dialog: false,
            edit_price_dialog: false,
            schedule_price_dialog: false,

            chosen_internet_user: {},
            export_csv: {
                loading: false,
                trigger: false,
                title: "",
                rows: []
            },
            wifi_type_badges: WIFI_TYPE_BADGES,
            internet_status: {
                0: {
                    text: "Mạng trống",
                    badge: "error"
                },
                1: {
                    text: "Đang hoạt động",
                    badge: "primary"
                },
                2: {
                    text: "Trả phòng",
                    badge: "warning"
                },
            },
            INTERNET_REGISTRATION_STATUS,
            expanded_users: []
        };
    },
    computed: {
        filtered_items() {
            const search = this.search && this.search.toLowerCase();

            let filtered = this.items.filter(item => {
                if (this.filterStatus !== null && item.status !== this.filterStatus) {
                    return false;
                }

                const buildingMatch = item.building && item.building.includes(this.chosen_building);
                if (!buildingMatch) return false;

                if (!search) return true;

                const roomMatch = item.room_id && item.room_id.toLowerCase().includes(search);
                const userMatch = item.user && item.user.toLowerCase().includes(search);
                const wifiTypeMatch = item.wifi_type && item.wifi_type.toLowerCase().includes(search);
                const wifiTypeTextMatch = this.wifi_type_badges[item.wifi_type] && 
                    this.wifi_type_badges[item.wifi_type].text.toLowerCase().includes(search);

                return roomMatch || userMatch || wifiTypeMatch || wifiTypeTextMatch;
            });

            const usersToInclude = new Set();
            
            filtered.forEach(item => {
                if (item.user) {
                    // Nếu là wifi phụ match, thêm user để include wifi chính
                    if (item.wifi_type === WIFI_TYPES.AUXILIARY) {
                        usersToInclude.add(item.user);
                    }
                    // Nếu là wifi chính match, thêm user để include tất cả wifi phụ
                    if (item.wifi_type === WIFI_TYPES.MAIN) {
                        usersToInclude.add(item.user);
                    }
                }
            });

            if (usersToInclude.size > 0) {
                this.items.forEach(item => {
                    if (usersToInclude.has(item.user)) {
                        const alreadyIncluded = filtered.some(f => 
                            f._id === item._id || 
                            (f.user === item.user && f.room_id === item.room_id && f.wifi_type === item.wifi_type)
                        );
                        if (!alreadyIncluded) {
                            const buildingMatch = item.building && item.building.includes(this.chosen_building);
                            if (buildingMatch && (this.filterStatus === null || item.status === this.filterStatus)) {
                                filtered.push(item);
                            }
                        }
                    }
                });
            }

            return filtered;
        },
        grouped_items() {
            const userGroups = {};

            this.filtered_items.forEach(item => {
                if (!userGroups[item.user]) {
                    userGroups[item.user] = {
                        main_items: [],
                        auxiliary_items: []
                    };
                }

                if (item.wifi_type === WIFI_TYPES.AUXILIARY) {
                    userGroups[item.user].auxiliary_items.push(item);
                } else {
                    userGroups[item.user].main_items.push(item);
                }
            });

            const result = [];

            Object.keys(userGroups).sort().forEach(user => {
                const group = userGroups[user];

                if (group.main_items.length > 0) {
                    group.main_items.forEach(item => {
                        item.has_auxiliary = group.auxiliary_items.length > 0;
                        result.push(item);
                    });
                } else if (group.auxiliary_items.length > 0) {
                    group.auxiliary_items.forEach(item => {
                        item.has_auxiliary = false;
                        result.push(item);
                    });
                }
            });

            return result.sort((a, b) => {
                if (a.user !== b.user) {
                    return a.user.localeCompare(b.user);
                }
                if (a.wifi_type !== b.wifi_type) {
                    return a.wifi_type.localeCompare(b.wifi_type);
                }
                return 0;
            });
        },
    },
    watch: {
        reload_table() {
            this.getData();
        },
        exportCSV() {
            this.startExportCSV();
        },
        search(newSearch) {
            if (newSearch) {
                this.$nextTick(() => {
                    const searchLower = newSearch.toLowerCase();
                    const usersToExpand = new Set();
                    
                    this.filtered_items.forEach(item => {
                        if (item.wifi_type === WIFI_TYPES.AUXILIARY) {
                            const roomMatch = item.room_id && item.room_id.toLowerCase().includes(searchLower);
                            const userMatch = item.user && item.user.toLowerCase().includes(searchLower);
                            if (roomMatch || userMatch) {
                                usersToExpand.add(item.user);
                            }
                        }
                    });
                    
                    usersToExpand.forEach(user => {
                        if (!this.expanded_users.includes(user)) {
                            this.expanded_users.push(user);
                        }
                    });
                });
            }
        }
    },
    methods: {
        getData: async function () {
            this.items = [];
            this.loader = true;
            try {
                let data = await api.getListInternet();
                this.loader = false;
                console.log("API response:", data);

                if (data.status === 200 && data.data && data.data.internet) {
                    this.items = data.data.internet
                        .map(item => {
                            item.status = this.updateItemStatus(item);
                            return item;
                        })
                        .filter(item => ![INTERNET_REGISTRATION_STATUS.CANCELLED, INTERNET_REGISTRATION_STATUS.PENDING].includes(item.registration_status))
                        .map(item => {
                            const building = list_building.find(
                                building => building.value == item.building
                            );
                            item.building_text = building ? building.text : item.building;

                            if (!item.wifi_type) item.wifi_type = WIFI_TYPES.PRIVATE;

                            return item;
                        });

                    // Expand all auxiliary wifis by default
                    this.expanded_users = [...new Set(
                        this.items
                            .filter(item => item.wifi_type === WIFI_TYPES.AUXILIARY)
                            .map(item => item.user)
                    )];
                } else {
                    console.log("Lỗi lúc tải internet:", data);
                }
            } catch (error) {
                this.loader = false;
                console.error("Lỗi getData:", error);
            }
        },

        updateItemStatus: function (item) {
            if (!item.room_state_id) return 0;
            else if (!item.date_schedule_out) return 1;
            return 2;
        },

        openDialog(internet_user, action) {
            this.closeAllDialogs();

            this.chosen_internet_user = { ...internet_user };
            if (action === "change") this.change_room_id_dialog = true;
            else if (action === "activate")
                this.activate_internet_dialog = true;
            else if (action === "cancel") this.cancel_internet_dialog = true;
            else if (action === "cut") this.cut_internet_dialog = true;
            else if (action === "add_room") this.add_room_dialog = true;
            else if (action === "edit_price") this.edit_price_dialog = true;
            else if (action === "schedule_price") {
                this.schedule_price_dialog = true;
            }
        },
        closeAllDialogs() {
            this.change_room_id_dialog = false;
            this.activate_internet_dialog = false;
            this.cancel_internet_dialog = false;
            this.cut_internet_dialog = false;
            this.add_room_dialog = false;
            this.edit_price_dialog = false;
        },
        updateInternetUser(internet_user) {
            const selected_user = this.items.find(
                user => user._id === internet_user._id
            );
            for (const key in selected_user) {
                if (
                    selected_user.hasOwnProperty(key) &&
                    internet_user.hasOwnProperty(key)
                ) {
                    const element = internet_user[key];
                    selected_user[key] = element;
                }
            }
            selected_user.status = this.updateItemStatus(selected_user);
        },
        toggleExpand(user) {
            if (this.expanded_users.includes(user)) {
                this.expanded_users = this.expanded_users.filter(u => u !== user);
            } else {
                this.expanded_users.push(user);
            }
        },
        getAuxiliaryItems(user) {
            return this.items.filter(item => item.user === user && item.wifi_type === WIFI_TYPES.AUXILIARY);
        },
        getHeaderClass(headerValue) {
            // Blue section - WiFi and user info
            if (['wifi_type', 'user', 'package_name', 'speed_mbps', 'action'].includes(headerValue)) {
                return 'header-blue';
            }
            // Pink section - Room, status, pricing
            if (['room_id', 'building', 'status', 'date_schedule_out', 'price', 'customer_price', 'date_start', 'wifi_name', 'wifi_password'].includes(headerValue)) {
                return 'header-pink';
            }
            // Green section - Renewal and discount
            if (['renewal_package_months', 'gifted_months', 'discount_percent', 'discount_amount', 'additional_discount'].includes(headerValue)) {
                return 'header-green';
            }
            // Yellow section - Renewal dates
            if (['renewal_start_date', 'renewal_end_date','vnpt_invoice'].includes(headerValue)) {
                return 'header-yellow';
            }
            return '';
        },
        startExportCSV() {
            const XLSX = require('xlsx');
            
            const rows = this.filtered_items.map(item => {
                return {
                    "Loại wifi": this.wifi_type_badges[item.wifi_type].text,
                    "Tên user": item.user,
                    "Tên gói cước": item.package_name || '',
                    "Tốc độ (Mbps)": item.speed_mbps || '',
                    "Số phòng": item.room_id,
                    "Tòa nhà": item.building_text,
                    "Trạng thái": this.internet_status[item.status].text,
                    "Ngày trả phòng": formatTimeServer(item.date_schedule_out),
                    "Giá gói cước": item.price,
                    "Giá thu KH": item.customer_price,
                    "Ngày bắt đầu": formatTimeServer(item.date_start),
                    "Tên wifi": item.wifi_name,
                    "Pass wifi": item.wifi_password,
                    "Ngày bắt đầu gia hạn": formatTimeServer(item.renewal_start_date),
                    "Ngày kết thúc gia hạn": formatTimeServer(item.renewal_end_date)
                };
            });

            // Tạo workbook và worksheet
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(rows);
            
            // Tô màu header
            const headerRange = XLSX.utils.decode_range(ws['!ref']);
            for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
                if (!ws[cellAddress]) ws[cellAddress] = { v: '' };
                ws[cellAddress].s = {
                    fill: { fgColor: { rgb: "4472C4" } },
                    font: { color: { rgb: "FFFFFF" }, bold: true },
                    alignment: { horizontal: "center", vertical: "center" }
                };
            }
            
            // Tô màu dữ liệu xen kẽ
            for (let row = 1; row <= headerRange.e.r; row++) {
                for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                    if (!ws[cellAddress]) ws[cellAddress] = { v: '' };
                    
                    if (row % 2 === 0) {
                        ws[cellAddress].s = {
                            fill: { fgColor: { rgb: "F2F2F2" } },
                            alignment: { horizontal: "center", vertical: "center" }
                        };
                    } else {
                        ws[cellAddress].s = {
                            fill: { fgColor: { rgb: "FFFFFF" } },
                            alignment: { horizontal: "center", vertical: "center" }
                        };
                    }
                }
            }
            
            // Auto-fit columns
            const colWidths = [];
            for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                let maxWidth = 10;
                for (let row = 0; row <= headerRange.e.r; row++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                    if (ws[cellAddress] && ws[cellAddress].v) {
                        const cellValue = String(ws[cellAddress].v);
                        maxWidth = Math.max(maxWidth, cellValue.length);
                    }
                }
                colWidths.push({ wch: maxWidth + 2 });
            }
            ws['!cols'] = colWidths;
            
            // Thêm worksheet vào workbook
            XLSX.utils.book_append_sheet(wb, ws, "Theo dõi Internet");
            
            // Xuất file
            const date = new Date().toISOString().substring(0, 10);
            XLSX.writeFile(wb, `internet-${date}.xlsx`);
        },
        async updateVnptInvoice(item) {
            try {
                const updateData = {
                    vnpt_invoice: item.vnpt_invoice
                };
                await api.updateInternet(item._id, updateData);
            } catch (error) {
                console.error('Lỗi cập nhật hóa đơn VNPT:', error);
            }
        }
    }
};
</script>

<style scoped>
.internet-table {

    tr td:nth-child(1),
    tr th:nth-child(1) {
        left: 0;
    }

    tr td:nth-child(2),
    tr th:nth-child(2) {
        left: 100px;
    }

    tr td:nth-child(3),
    tr th:nth-child(3) {
        left: 200px;
    }

    td:nth-child(1),
    td:nth-child(2),
    td:nth-child(3),
    th:nth-child(3),
    th:nth-child(2),
    th:nth-child(1) {
        position: sticky;
        z-index: 1 !important;
        background-color: white;
    }

    .v-table__overflow {
        overflow: unset !important;
    }
    .custom-data-table {
        position: relative !important;
        max-height: 70vh !important;
        overflow-y: auto !important;
    }

    .custom-data-table>>>.v-table,
    .custom-data-table>>>.v-table__overflow,
    .custom-data-table>>>.v-data-table__wrapper {
        overflow: visible !important;
    }

    tr.first-header {
        position: sticky !important;
        z-index: 2;
        top: 0 !important;
    }

    .header-blue {
        background-color: #e3f2fd !important;
        color: #1976d2 !important;
    }

    .header-pink {
        background-color: #fce4ec !important;
        color: #c2185b !important;
    }

    .header-green {
        background-color: #e8f5e8 !important;
        color: #2e7d32 !important;
    }

    .header-yellow {
        background-color: #fff8e1 !important;
        color: #f57c00 !important;
    }
}
</style>